import React from 'react';

interface AiSuggestedBadgeProps {
  /** When true, show the subtle "Suggested" indicator. */
  show?: boolean;
  className?: string;
}

/** Subtle, non-warning indicator that a field was AI/parser suggested. */
export const AiSuggestedBadge: React.FC<AiSuggestedBadgeProps> = ({
  show = true,
  className = '',
}) => {
  if (!show) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wide text-orange-300/80 bg-orange-500/10 border border-orange-500/25 rounded px-1.5 py-0.5 ${className}`}
      title="Suggested: you can change this"
    >
      <span aria-hidden>✓</span>
      Suggested
    </span>
  );
};
